import { SvgIcon } from '@mui/material';

// Generic four-point sparkle. Original mark, not a vendor logo.
const SVG = ({ fill = '#5B6CFF' }) => {
  return (
    <SvgIcon
      style={{ width: '24px', height: '24px', fill }}
      viewBox="0 0 32 32"
    >
      <svg
        version="1.0"
        xmlns="http://www.w3.org/2000/svg"
        width="32"
        height="32"
        viewBox="0 0 32 32"
        preserveAspectRatio="xMidYMid meet"
      >
        <path d="M16 3 C17 11 21 15 29 16 C21 17 17 21 16 29 C15 21 11 17 3 16 C11 15 15 11 16 3 Z" />
      </svg>
    </SvgIcon>
  );
};
export default SVG;
